import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

// https://codepen.io/hagiang1305/pen/vyobEK

import '../scss/slider.scss';
import 'swiper/css';
import 'swiper/css/navigation';

document.addEventListener('DOMContentLoaded', () => {

    const swiper = new Swiper('.slider-home', {
        modules: [Autoplay, Navigation],
        slidesPerView: 1,
        // centeredSlides: true,
        loop: true,
        navigation: {
            prevEl: ".slider-home-prev",
            nextEl: ".slider-home-next",
        },
        /* autoplay: {
            delay: 5000,
        }, */
        breakpoints: {
            769: {
              slidesPerView: 2,
              centeredSlides: true
            }
        },
    });

    const related = new Swiper('.latest-wrapper', {
        modules: [Autoplay, Navigation],
        slidesPerView: 1,
        loop: true,
        navigation: {
            prevEl: ".slider-latest-prev",
            nextEl: ".slider-latest-next",
        },
        spaceBetween: 80,
        breakpoints: {
            600: {
              slidesPerView: 2
            }
        },
    });

})